import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-700/50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                韩漫大全
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              无删减韩漫在线观看平台，提供最全面、最高质量的韩国漫画资源。涵盖爱情、悬疑、奇幻等多种题材。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-foreground-50 font-semibold mb-4 text-sm">
              漫画分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-50 font-semibold mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  最新更新
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-50 font-semibold mb-4 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@manhuakr.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>韩漫大全官方</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区望京SOHO</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 韩漫大全 - 版权所有 | 无删减韩漫在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors whitespace-nowrap" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors whitespace-nowrap" rel="nofollow">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}